export const sectionsMap = {
  home: "home",
  about: "about",
  choose: "choose",
  process: "process",
  contacts: "contacts",
};